import createStaticResourceAPI from "@/helpers/rtk_static_resource_factory";
const type = 'HOSPITALS';

export const hospitalsAPI = createStaticResourceAPI({
    baseURL: `${process.env.REACT_APP_GLOBO_API}/staticdata/hospitals`,
    resource: "Hospitals",
    idKey: "hospitalId",
    tagTypes: ["GLOBO", "Hospitals"],
    lookupMap: ({ hospitalId, hospitalName }) => ({
        value: hospitalId,
        label: hospitalName,
    }),
    getInvalidationTags: ({ mode, patch }) => {
        const tags = [{ type: type, id: type }];
        if (mode === 'save' || mode === 'delete') {
            tags.push({ type: type, id: patch.hospitalId });
        }
        return tags; 
    },
});

export const {
    useGetHospitalsQuery,
    useFindHospitalsQuery,
    useLookUpHospitalsMutation,
    useDeleteHospitalsMutation,
    useSaveHospitalsMutation,
    useExportHospitalsMutation,
} = hospitalsAPI;
